import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { cn } from '../../primitives/utils';
import { Skeleton } from '../../primitives/skeleton';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarMenuSkeleton',
    props: {
        showIcon: { type: Boolean, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const width = computed(() => {
            return `${Math.floor(Math.random() * 40) + 50}%`;
        });
        const __returned__ = { props, width, get cn() { return cn; }, get Skeleton() { return Skeleton; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
